import React from 'react';
import style from './additionalInfo.module.scss';
import WifiIcon from 'acscp/assets/wifi.svg';
import CateringIcon from 'acscp/assets/catering.svg';
import CarIcon from 'acscp/assets/car.svg';
import HelicopterIcon from 'acscp/assets/helicopter.svg';
import MeetIcon from 'acscp/assets/meet.svg';
import PlusIcon from 'acscp/assets/plus.svg';
import { FormattedMessage } from 'react-intl';
import { ItineraryAdditionalInformation } from 'acscp/store';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';
import { isEmpty } from 'acscp/components/common/helpers/isEmpty';
import { AdditionalItem } from './additionalItem';

const AdditionalInformationContent: React.SFC<{additionalInformation: ItineraryAdditionalInformation}> =
    ({additionalInformation}) => {

    if (isEmpty(additionalInformation)) {
        return null;
    }

    return (
        <div className={style.Container}>
            <div className={style.InnerContainer}>
                <AdditionalItem
                    icon={WifiIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.additionalInfo.wifiCharges'}
                        defaultMessage={'Wifi Charges'}
                    />}
                >
                    {additionalInformation.wifiCharges}
                </AdditionalItem>
                <AdditionalItem
                    icon={CateringIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.additionalInfo.catering'}
                        defaultMessage={'Catering'}
                    />}
                >
                    {additionalInformation.catering}
                </AdditionalItem>
                <AdditionalItem
                    icon={CarIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.additionalInfo.groundTransportation'}
                        defaultMessage={'Ground Transportation'}
                    />}
                >
                    {additionalInformation.groundTransportation}
                </AdditionalItem>
                <AdditionalItem
                    icon={HelicopterIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.additionalInfo.helicopter'}
                        defaultMessage={'Helicopter Connection'}
                    />}
                >
                    {additionalInformation.helicopterConnection}
                </AdditionalItem>
                <AdditionalItem
                    icon={MeetIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.additionalInfo.meetAndGreet'}
                        defaultMessage={'Meet and Greet Service'}
                    />}
                >
                    {additionalInformation.meetAndGreetService}
                </AdditionalItem>
                <AdditionalItem
                    icon={PlusIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.additionalInfo.services'}
                        defaultMessage={'Additional Services'}
                    />}
                >
                    {additionalInformation.additionalServices}
                </AdditionalItem>
            </div>
        </div>
    );
};

const AdditionalInformation = withCollapsable(
    (
        <Title>
            <FormattedMessage id={'web.components.itinerary.otherInformationTitle'} defaultMessage={'OTHER INFORMATION'} />
        </Title>
    ),
    AdditionalInformationContent);

export { AdditionalInformation };
